// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3UlvZ","col":"styles_col__3KBju"};